import styled from 'styled-components';
import SmallInput from '../../../components/utils/inputs/SmallInput/SmallInput';
import { Transition } from '../../../styles/constants';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2.4rem;
  flex-grow: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const TitleRightSide = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
`;

export const RecentlyAddedButton = styled.button`
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: 10px;
  border: 1px solid ${({ $active }) => ($active ? '#61ADE9' : '#97C9F1')};
  background: ${({ $active }) => ($active ? '#3E9BE4' : '#D8EAF9')};
  color: ${({ $active }) => ($active ? '#fff' : '#1672BA')};
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1;
  letter-spacing: -0.408px;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  transition: ${Transition.hover.off};

  &:hover {
    transition: ${Transition.hover.on};
    background: ${({ $active }) => ($active ? '#1672BA' : '#C5E0F8')};
  }
`;

export const Input = styled(SmallInput)`
  width: 19rem;
  input {
    height: 3.4rem;
  }
`;
